import React from 'react'
import ItemWithStatusOperable from '../ItemSelectable/ItemWithStatusOperable'
import vehicleImg from '../../assets/vehicle-select-icon.svg';

const VehicleVisit = ({ visitVehicle, onClickEdit, onClickDelete }) => {
    return (
        <ItemWithStatusOperable
            onClickDelete={onClickDelete}
            onCLickEdit={onClickEdit}
        >
            <div className='d-flex align-items-center gap-2'>
                <img src={vehicleImg} alt="" />
                <div>
                    <p className='m-0 vehicleName-card'>{visitVehicle.description}</p>
                    <p className='m-0 vehiclePatent-card'>{visitVehicle.plate_number}</p>
                </div>
            </div>
        </ItemWithStatusOperable>

    )
}

export default VehicleVisit